console.log('加载 myUserApi.js');
import myRequest from '@/utils/myRequest';

/**
 * 检查是否为开发环境
 * @returns {boolean} 是否为开发环境
 */
export function isDevelopmentMode() {
  return process.env.NODE_ENV === 'development';
}

/**
 * 用户注册
 * @param {Object} data - 注册信息
 * @param {string} data.userAccount - 用户账号
 * @param {string} data.userPassword - 用户密码
 * @param {string} data.checkPassword - 确认密码
 * @returns {Promise<number>} - 返回用户ID
 */
export function myRegister(data) {
  return myRequest({
    url: '/api/user/register',
    method: 'post',
    data
  });
}

/**
 * 用户登录
 * @param {Object} data - 登录信息
 * @param {string} data.userAccount - 用户账号
 * @param {string} data.userPassword - 用户密码
 * @returns {Promise<Object>} - 返回用户信息
 */
export function myLogin(data) {
  console.log('调用登录API，参数:', data);
  return myRequest({
    url: '/api/user/login',
    method: 'post',
    data
  }).then(response => {
    console.log('登录API响应成功:', response);
    return response;
  }).catch(error => {
    console.log('登录API响应失败:', error);
    throw error;
  });
}

/**
 * 获取当前登录用户信息
 * @returns {Promise<Object>} - 返回当前用户信息
 */
export function myGetCurrentUser() {
  return myRequest({
    url: '/api/user/current',
    method: 'get'
  });
}

/**
 * 用户登出
 * @returns {Promise<number>} - 返回1表示成功
 */
export function myLogout() {
  return myRequest({
    url: '/api/user/logout',
    method: 'post'
  });
}

/**
 * 分页获取用户列表（管理员）
 * @param {Object} params - 查询参数
 * @param {number} params.current - 当前页码
 * @param {number} params.pageSize - 每页大小
 * @param {string} [params.keyword] - 搜索关键词（可选，支持用户名、账号、邮箱）
 * @returns {Promise<Object>} - 返回分页结果
 */
export function myPageUsers(params) {
  return myRequest({
    url: '/api/user/admin/page',
    method: 'get',
    params
  });
}

/**
 * 删除用户（管理员）
 * @param {number} userId - 用户ID
 * @returns {Promise<boolean>} - 返回删除结果
 */
export function myDeleteUser(userId) {
  return myRequest({
    url: `/api/user/admin/${userId}`,
    method: 'delete'
  });
}

/**
 * 批量删除用户（管理员）
 * @param {Array<number>} userIds - 用户ID列表
 * @returns {Promise<boolean>} - 返回删除结果
 */
export function myBatchDeleteUsers(userIds) {
  return myRequest({
    url: '/api/user/admin/batch',
    method: 'delete',
    data: { userIds }
  });
} 

/**
 * 更新单个用户状态（管理员）
 * @param {number} userId - 用户ID
 * @param {number} status - 用户状态（0-正常，1-禁用）
 * @returns {Promise<boolean>} - 返回更新结果
 */
export function myUpdateUserStatus(userId, status) {
  return myRequest({
    url: `/api/user/admin/${userId}/status`,
    method: 'put',
    data: { status }
  });
}

/**
 * 批量更新用户状态（管理员）
 * @param {Array<number>} userIds - 用户ID列表
 * @param {number} status - 用户状态（0-正常，1-禁用）
 * @returns {Promise<boolean>} - 返回更新结果
 */
export function myBatchUpdateUserStatus(userIds, status) {
  return myRequest({
    url: '/api/user/admin/status/batch',
    method: 'put',
    data: { userIds, status }
  });
}